const Labels = {
  notify_cust_reply: 'A',
  notify_inspec_comp: 'D',
  notify_cust_open: 'C',
  notify_qc_comp: 'Q',
  notify_wo_comp: 'W',
  notify_kiosk: 'K',
  notify_bot_response: 'B',
  notify_sw_assignments: 'S',
  notify_tech_assignments: 'T',
  notify_ic_messages: 'I',
  notify_wo_assignments: 'W',
  notify_internal_reminders: 'I',
  notify_inbound_marketing_response: 'M',
};

const notificationLabel = (notification) => {
  return Labels[notification] ?? 'N';
};

export { notificationLabel };
